import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import SlickSlider from '../common/SlickSlider';
import List from '../common/List';
import ProductListItem from '../common/ProductListItem';
import api from "../../config/api";
import {completeUrlForArticleList, completeUrlForSlider, completeUrls, getDateByLocaleFormat} from "../../util/utils";
import SearchForm from "../form/SearchForm";
import {FormattedMessage} from "react-intl";

class MainPage extends Component{

	constructor(){
		super();
		this.state = {
			slider: [],
			featured: [],
			articles: [],
		};
	}

	/**
	 * Component did mount lifecycle
	 */
	componentDidMount(){
		const {selectedLanguage} = this.props;
		this.loadSlider(selectedLanguage);
		this.loadFeatured(selectedLanguage);
		this.loadArticles(selectedLanguage);
	}

	/**
	 * Load other products if the route is changed
	 * @param nextProps - the props that will be received next
	 */
	componentWillReceiveProps(nextProps) {
		const {selectedLanguage, match} = nextProps;
		if(this.props.match.url !== match.url) {
			this.setState({
				slider: [],
				featured: [],
			});
			this.loadSlider(selectedLanguage);
			this.loadFeatured(selectedLanguage);
			this.loadArticles(selectedLanguage);
		}
	}

	/**
	 * Load slider data from API
	 */
	loadSlider = (language) => {
		fetch(api.slider(language.codeCountry))
			.then(res => res.json())
			.then(data => {
				this.setState({slider: completeUrlForSlider(data)});
			}).catch(err => {
				console.error(err);
			});
	};


	/**
	 * Load featured products from API
	 */
	loadFeatured = (language) => {
		fetch(api.featured(language.codeCountry))
			.then(res => res.json())
			.then(data => {
				this.setState({featured: completeUrls(data)});
			}).catch(err => console.error(err));
	};

	/**
	 * Load featured products from API
	 */
	loadArticles = (language) => {
		fetch(api.article(language.codeCountry,3))
			.then(res => res.json())
			.then(data => {
				this.setState({articles: completeUrlForArticleList(data)});
			}).catch(err => console.error(err));
	};


	/**
	 *
	 * @param slider
	 * @param index
	 * @returns {*}
	 */
	renderProductSlider = (slider, index) => {

		const {localizePath} = this.props;

		if(slider.type === 'BANNER'){
			if(slider.name.includes('Ifa')){
				return (
					<a href="https://www.virtualmarket.ifa-berlin.de/en/Edictum,c508805" target="_blank" className="main-slider__item" key={index} >
						<div className="main-slider__item-banner"
						     style={{backgroundImage: 'url(' + slider.imageUrl + ')'}}
						     title={slider.name}/>
					</a>
				);
			}
			return (
				<div className="main-slider__item" key={index}>
					<div className="main-slider__item-banner"
					     style={{backgroundImage: 'url(' + slider.imageUrl + ')'}}
					     title={slider.name}/>
				</div>
			);
		}

		if(slider.type === 'ITEM'){
			return (
				<Link to={localizePath("/product/"+slider.url)} className="main-slider__item" key={index}>
					<img className="main-slider__item-image" src={slider.imageUrl} alt={slider.name}/>
					<div className="main-slider__item-details">
						<h3 className="main-slider__item-title">
							{slider.name}
						</h3>
						<div className="main-slider__item-description"
						     dangerouslySetInnerHTML={ { __html: slider.description } } />
					</div>
				</Link>
			);
		}

		return null;
	};

	/**
	 * 
	 * @param featured
	 * @returns {XML}
	 */
	renderProductList = (featured) => {
		const {localizePath} = this.props;
		return <ProductListItem
			key={featured.id}
			product={featured}
			localizePath={localizePath}
		/>;
	};

	renderArticleImage = (article) => {
		if(article.image === null){
			return null;
		}
		const style = {
			backgroundImage: "url("+article.image+""
		};
		return <div className="main-page__article-image" style={style}/>;
	};

	renderArticle = (article, index) => {
		const {localizePath, selectedLanguage} = this.props;
		return (
			<div className="main-page__article" key={index}>
				{this.renderArticleImage(article)}
				<h4 className="main-page__article-title">{article.title}</h4>
				<p className="main-page__article-prolog">{article.prolog}</p>
				<section className="main-page__article-bottom">
						<span className="main-page__article-date">
							{getDateByLocaleFormat(article.createdAt,selectedLanguage.codeCountry)}
						</span>
					<Link className="btn btn-more main-page__article-btn" to={localizePath("/article/" + article.url)}>
						<FormattedMessage id="home.article.read-more"/>
					</Link>
				</section>
			</div>
		)
	};

	renderArticleSection = () => {
		const {localizePath} = this.props;
		const {articles} = this.state;
		if(articles.length <= 0){
			return null;
		}

		return (
			<div className="main-article">
				<h3 className="main-page__section-title">
					<FormattedMessage id="home.title.news" />
				</h3>
				<div className="main-page__article-list">
					{articles.map(this.renderArticle)}
				</div>
				<Link className="btn btn-all-article" to={localizePath("/articles")}>
					<FormattedMessage id="home.article.all" />
					<i className="fa fa-angle-right"/>
				</Link>
			</div>
		);
	};

	renderProductSection = () => {
		const {featured} = this.state;
		if(featured.length <= 0){
			return null;
		}
		return (
			<div className="main-featured">
				<h3 className="main-page__section-title">
					<FormattedMessage id="home.title.products" />
				</h3>
				<List
					className="product-list product-list--main-page"
					items={featured.sort((a,b) => a.name.localeCompare(b.name)).map(this.renderProductList)}/>
			</div>
		);
	};

	renderSearchContainer = () => {
		const {selectedLanguage} = this.props;

		if(selectedLanguage.codeCountry === "hu_HU"){
			return (
				<div className="main-search-container">
					<SearchForm {...this.props} />
					<Link className="eu-project-link" to="/nyertespalyazat_erfa" />
				</div>
			);
		}

		return (
			<SearchForm {...this.props} />
		);
	};

	render(){

		const {slider} = this.state;

		return (
			<div className="container-flex">
				<SlickSlider
					className="main-slider"
					sliderContent={slider.map(this.renderProductSlider)} />
				{this.renderSearchContainer()}
				{this.renderArticleSection()}
				{this.renderProductSection()}
			</div>
		);
	}
}

export default MainPage;


// WEBPACK FOOTER //
// ./src/components/page/MainPage.js